export default "__VITE_ASSET__rx7erA3D__";